exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2HwZTce1zKwQJyzgqXpmAy{color:\"[theme:themePrimary, default:#0078D4]\";cursor:pointer}html[dir] ._2HwZTce1zKwQJyzgqXpmAy{padding:1px 0;border-bottom:1px;border-bottom-style:dashed;border-bottom-color:\"[theme:themePrimary, default:#0078D4]\"}", ""]);
// Exports
exports.locals = {
	"contextualAddinHighlight": "_2HwZTce1zKwQJyzgqXpmAy"
};